module.exports = __webpack_public_path__ + "static/media/sap.c60a7985.png";